export default {
  backHome: "← Retour à l'accueil",
  articleNotFound: "Guide introuvable.",
  moreGuides: "Découvrez d'autres guides d'achat originaux sur le spreadsheet AllChinaBuy.",
  browseGuides: "Parcourir tous les guides",
  published: "Publié",
  updated: "Dernière mise à jour",
  author: "Par l'équipe AllChinaBuy Spreadsheet",
  readTime: "min de lecture",

  title: "AllChinaBuy Spreadsheet : Le Guide d'Achat Complet",
  metaTitle: "AllChinaBuy Spreadsheet : Le Guide d'Achat Complet (2026)",
  metaDescription: "Un guide complet du spreadsheet AllChinaBuy — trouver des produits, évaluer les vendeurs, lire les photos QC et choisir l'expédition. Des conseils originaux et orientés acheteur pour des achats plus malins.",

  intro: "Le spreadsheet AllChinaBuy est devenu un moyen populaire pour les acheteurs d'organiser leurs trouvailles, de comparer les vendeurs et de suivre les contrôles qualité avant de passer commande. Ce guide explique ce qu'est le spreadsheet, comment l'utiliser et comment éviter les erreurs les plus courantes — afin d'acheter avec de meilleures informations et moins d'incertitude.",

  tocTitle: "Table des Matières",

  sections: [
    {
      id: "what-is",
      heading: "Qu'est-ce que le Spreadsheet AllChinaBuy ?",
      body: [
        "Le spreadsheet AllChinaBuy est un document structuré qui regroupe les liens produits, les détails vendeurs, les notes de contrôle qualité (QC) et les informations d'expédition dans une seule vue. Au lieu de garder des dizaines d'onglets ouverts, les acheteurs l'utilisent pour comparer les articles côte à côte et repérer les options les plus fiables.",
        "Un spreadsheet AllChinaBuy typique regroupe les articles par catégorie — chaussures, hoodies, t-shirts, vestes, sacs, accessoires et plus — puis ajoute des colonnes pour le statut QC, la fiabilité du vendeur, des notes utiles et la date de dernière mise à jour. Cette structure transforme une liste de liens désordonnée en une ressource claire et filtrable.",
      ],
    },
    {
      id: "how-to-use",
      heading: "Comment utiliser le Spreadsheet",
      body: [
        "Commencez par choisir une catégorie qui vous intéresse, puis parcourez les lignes à la recherche d'articles correspondant à vos goûts et à votre budget. Prêtez attention à la colonne QC — les articles marqués comme vérifiés sont généralement accompagnés de photos et de dimensions confirmées, tandis que les articles non marqués nécessitent des recherches supplémentaires avant de vous engager.",
        "Utilisez la colonne vendeur pour vérifier si un vendeur propose des annonces cohérentes et fiables. La date de dernière mise à jour compte aussi : les informations évoluent vite, privilégiez donc les lignes actualisées récemment.",
      ],
    },
    {
      id: "evaluate-sellers",
      heading: "Comment évaluer les vendeurs",
      body: [
        "Un bon vendeur propose généralement des photos produit détaillées, des tableaux de tailles précis et un historique d'annonces cohérentes. Lorsque vous comparez les vendeurs dans le spreadsheet AllChinaBuy, recherchez ceux qui offrent des informations QC claires et moins de plaintes concernant les différences de taille ou de matière.",
        "Ne vous fiez pas à une seule annonce. Recoupez le même produit entre catégories lorsque c'est possible, et traitez les informations manquantes comme un signal pour poser des questions plutôt qu'une raison d'écarter l'article.",
      ],
    },
    {
      id: "qc-photos",
      heading: "Lire les photos QC",
      body: [
        "Les photos QC sont votre meilleure protection contre les mauvaises surprises. Recherchez des images qui montrent le produit réel, pas seulement des rendus studio — vérifiez les coutures, logos, étiquettes, l'exactitude des couleurs et les mesures. Un jeu QC utile inclut des gros plans des détails faciles à rater.",
        "Lorsque vous examinez les photos QC dans le contexte du spreadsheet AllChinaBuy, comparez-les à l'annonce d'origine. Si quelque chose semble différent, demandez des précisions avant l'expédition.",
      ],
    },
    {
      id: "shipping",
      heading: "Expédition et coûts",
      body: [
        "Le coût d'expédition internationale dépend de la destination, du poids du colis et de la ligne d'expédition choisie. Les articles plus lourds comme les vestes et les chaussures coûtent plus cher à expédier, tandis que les accessoires légers et les t-shirts sont moins chers. Utilisez les guides d'expédition du spreadsheet pour estimer les coûts avant de commander.",
        "Le délai de livraison varie selon le transporteur et la destination. Les lignes plus rapides coûtent plus cher mais arrivent plus tôt ; les lignes économiques font économiser mais prennent plus de temps. Choisissez selon l'urgence et votre budget.",
      ],
    },
    {
      id: "mistakes",
      heading: "Erreurs courantes à éviter",
      body: [
        "L'une des erreurs les plus courantes est d'ignorer les informations QC et de commander à l'aveugle. Une autre est de choisir la mauvaise taille parce que le tableau des tailles a été ignoré. Les deux sont faciles à éviter lorsque vous utilisez systématiquement les notes et les champs QC du spreadsheet.",
        "Se précipiter pour expédier sans examiner les photos QC finales est également risqué. Prenez le temps de confirmer que tout est correct — c'est bien moins coûteux que de découvrir un problème une fois le colis parti de l'entrepôt.",
      ],
    },
  ],

  ctaTitle: "Prêt à parcourir les trouvailles organisées ?",
  ctaDesc: "Continuez vers le site principal pour explorer le spreadsheet AllChinaBuy complet, organisé par catégorie, avec les informations QC et vendeur.",
  ctaLabel: "Explorer le Spreadsheet AllChinaBuy",
  buyLabel: "Acheter Maintenant",
  backLabel: "Retour au Centre de Ressources",
};